const slideImages = [
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_01.jpg?v=1603879571',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_02.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_03.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_04.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_05.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_06.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_07.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_08.jpg?v=1603202279',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_09.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_10.jpg?v=1603202278',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_11.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_12.jpg?v=1603879145',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_13.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_14.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_15.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_16.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_17.jpg?v=1603879144',
  'https://cdn.shopify.com/s/files/1/0497/0378/0504/files/slide_product_18.jpg?v=1603879144'
];

// 画像プリロード用関数
const getImages = () => {
  const slideShowContent = document.getElementById('slideshow-content');
  
  // index以外の画面では実行しない
  if (!slideShowContent) {
    return;
  }

  for (i = 0; i < slideImages.length; i += 1){
    const img = document.createElement('img');
    img.src = slideImages[i];
  }
}

const slideShowExec = () => {
	const slideShowContent = document.getElementById('slideshow-content');
  
    // index以外の画面では実行しない
    if (!slideShowContent) {
      return;
    }

	let index = 0;
  
    const slideShowImg = document.createElement('img');
  	slideShowImg.src = slideImages[index];
  	slideShowImg.id = 'slideshow-img';
	slideShowImg.alt = 'slideshow-img';

	slideShowContent.appendChild(slideShowImg);

	setInterval(() => {
	    // まずはお掃除から
　　　　	const prevImg = document.getElementById('slideshow-img');
  		if (prevImg) {
          	slideShowContent.removeChild(prevImg);
        }

    	if (index < slideImages.length - 1) {
      		index += 1;
    	}
  
  		if (index === slideImages.length - 1) {
      		index = 0;
  		}
     
  		const slideShowImg = document.createElement('img');
  		slideShowImg.src = slideImages[index];
  		slideShowImg.id = 'slideshow-img';
		slideShowImg.alt = 'slideshow-img';
  
    	slideShowContent.appendChild(slideShowImg);
  	}, 8000);
};

const footerMenuTranslate = () => {
  const path = location.pathname ;
  // pathが英語だった時 = 訳す時
  if (path.indexOf('/en/') === 0) {    
    const shopNameElement = document.getElementById('shop-name');
    shopNameElement.innerText = '© 2021, Tanicushion Official Online Store';

    const privacyElement = document.getElementById('policy-privacy');
    privacyElement.innerText = 'Privacy Policy';
    
    const legalElement = document.getElementById('policy-legal');
    legalElement.innerText = 'Legal Notice';
  }
}

window.onload = () =>　{
  // 画像プリロード
  getImages();
  // スライドショー実行
  slideShowExec();
  // footerメニュー（ポリシー部分）変更
  footerMenuTranslate();
}


